

import { PublicFooter, PublicMenu } from '../components/public';



type PublicLayoutProps = {
    children: React.ReactNode;
}

export const PublicLayout = ({ children }: PublicLayoutProps) => {
    return (
        <>
            <PublicMenu />


            {children}


            <PublicFooter />
        </>
    )
}
